export default "__VITE_ASSET__4ef035c6__"